var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.0378C0 5.14673 4.77563 0.371094 10.6667 0.371094H85.3333C91.2244 0.371094 96 5.14672 96 11.0378V85.7044C96 91.5955 91.2244 96.3711 85.3333 96.3711H10.6667C4.77563 96.3711 0 91.5955 0 85.7044V11.0378Z",
    fill: "url(#paint0_linear_1972_80250)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1972_80250",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 64,
    height: 65
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.3711H80V80.3711H16V16.3711Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1972_80250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0267 73.4638C53.0045 74.486 51.7378 74.9971 50.2267 74.9971C48.7156 74.9971 47.4489 74.486 46.4267 73.4638L22.96 49.9971C22.4711 49.5082 22.0822 48.9305 21.7933 48.2638C21.5045 47.5971 21.36 46.886 21.36 46.1305V27.0638C21.36 25.5971 21.8822 24.3416 22.9267 23.2971C23.9711 22.2527 25.2267 21.7305 26.6933 21.7305H45.76C46.5156 21.7305 47.2267 21.8749 47.8933 22.1638C48.56 22.4527 49.1378 22.8416 49.6267 23.3305L73.0933 46.8638C74.1156 47.886 74.6267 49.1416 74.6267 50.6305C74.6267 52.1194 74.1156 53.3749 73.0933 54.3971L54.0267 73.4638ZM50.2267 69.7305L69.2934 50.6638L45.76 27.0638H26.6933V46.1305L50.2267 69.7305ZM33.36 37.7305C34.4711 37.7305 35.4156 37.3416 36.1933 36.5638C36.9711 35.786 37.36 34.8416 37.36 33.7305C37.36 32.6194 36.9711 31.6749 36.1933 30.8971C35.4156 30.1194 34.4711 29.7305 33.36 29.7305C32.2489 29.7305 31.3045 30.1194 30.5267 30.8971C29.7489 31.6749 29.36 32.6194 29.36 33.7305C29.36 34.8416 29.7489 35.786 30.5267 36.5638C31.3045 37.3416 32.2489 37.7305 33.36 37.7305Z",
    fill: "url(#paint1_linear_1972_80250)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1972_80250",
    x1: 0,
    y1: 96.3711,
    x2: 113.373,
    y2: 66.6559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFE3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1972_80250",
    x1: 21.36,
    y1: 74.9971,
    x2: 84.2664,
    y2: 58.5093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/price_tag.477e21aaa9ebcb5b011a87bf7b1162e4.svg";
export { ForwardRef as ReactComponent };